<template>
  <div
    class="mc-optcard"
    :class="{ 'is-sel': selected }"
    @click="$emit('click')"
  >
    <div class="mc-dot" />
    <div v-if="$slots.icon" class="mc-ico"><slot name="icon" /></div>
    <div class="mc-txt">
      <b>{{ title }}</b>
      <span v-if="subtitle">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionCard',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    selected: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.mc-optcard {
  display: flex;
  gap: 13px;
  align-items: flex-start;
  background: #fff;
  border: 1.5px solid #e8e8e8;
  border-radius: 14px;
  padding: 15px;
  margin-bottom: 11px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}

.mc-optcard:active {
  transform: scale(0.995);
}

.mc-optcard.is-sel {
  border-color: #0066cc;
  background: #eef3ff;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.09);
}

.mc-dot {
  width: 21px;
  height: 21px;
  flex: 0 0 21px;
  border-radius: 50%;
  border: 2px solid #a0a3bd;
  margin-top: 2px;
  display: grid;
  place-items: center;
  transition: border-color 0.15s;
}

.mc-optcard.is-sel .mc-dot {
  border-color: #0066cc;
}

.mc-optcard.is-sel .mc-dot::after {
  content: '';
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #0066cc;
}

.mc-ico {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  border-radius: 11px;
  background: #eef3ff;
  display: grid;
  place-items: center;
  color: #0052b3;
}

.mc-txt b {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #14142b;
  line-height: 1.35;
}

.mc-txt span {
  display: block;
  font-size: 12.5px;
  color: #6e7191;
  margin-top: 3px;
  line-height: 1.45;
}
</style>
